import React, { useId, useState } from 'react';
import styles from '../styles/CaseStudyPage.module.css';

interface CaseStudyToggleGroupProps {
  items: Array<{ title: string; body: string }>;
}

const CaseStudyToggleGroup: React.FC<CaseStudyToggleGroupProps> = ({ items }) => {
  const groupId = useId();
  const [open, setOpen] = useState<Set<number>>(() => new Set());

  const toggle = (idx: number) => {
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  return (
    <div className={styles.toggleGroup}>
      {items.map((item, idx) => {
        const isOpen = open.has(idx);
        const panelId = `${groupId}-panel-${idx}`;
        return (
          <div key={idx} className={styles.toggleItem}>
            <button
              type="button"
              className={styles.toggleHead}
              onClick={() => toggle(idx)}
              aria-expanded={isOpen}
              aria-controls={panelId}
            >
              <span className={styles.toggleChevron} aria-hidden>
                {isOpen ? '−' : '+'}
              </span>
              <span className={styles.toggleTitle}>{item.title}</span>
            </button>
            <div
              className={styles.togglePanel}
              hidden={!isOpen}
              id={panelId}
              role="region"
            >
              <p className={styles.toggleBody}>{item.body}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CaseStudyToggleGroup;
